import {
  defaultBackgroundColor,
  defaultCorrect,
  defaultIncorrect,
  defaultPartiallyCorrect,
  defaultUnanswered,
} from '../cssUtils.js';

import {
  maxResponseDefaultWidth,
  minResponseDefaultWidth,
} from './cssUtils.js';

export const styles = `
  .ct-item {
    display: flex;
    font-family: var(--pie-ct-live-font-family, sans-serif);
  }

  .ct-group {
    margin: 12px;
    width: fit-content;
  }

  .ct-group_header-correctness-indicator {
    height: 12px;
    width: 100%;
    border-radius: 4px 4px 0 0;
    background-color: var(
      --pie-live-session-background-color,
      ${defaultBackgroundColor}
    );
  }

  .ct-group_header-correctness-indicator.correct {
    background-color: var(--pie-live-session-correct, ${defaultCorrect});
  }

  .ct-group_header-correctness-indicator.incorrect {
    background-color: var(--pie-live-session-incorrect, ${defaultIncorrect});
  }

  .ct-group_header-correctness-indicator.correct-partially {
    background-color: var(
      --pie-live-session-partial,
      ${defaultPartiallyCorrect}
    );
  }

  .ct-group_header-correctness-indicator.unanswered {
    background-color: var(--pie-live-session-unanswered, ${defaultUnanswered});
  }

  .correctness-label {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.106611px;
    margin-bottom: 8px;
  }

  .correctness-label.hidden {
    visibility: hidden;
  }

  .ct-subgroups {
    display: flex;
  }

  .ct-subgroups.ct-row {
    flex-direction: column;
  }

  .ct-subgroup {
    box-shadow: rgb(0 0 0 / 10%) 0 1px 8px 1px;
    border-radius: 0 0 4px 4px;
    height: fit-content;
    margin-left: 16px;
    margin-bottom: 16px;
    min-width: ${minResponseDefaultWidth}px;
    background: white;
    overflow: hidden;
  }

  .ct-subgroup.first {
    margin-left: 0;
  }

  .block {
    border-bottom: 1px solid #e0e1e6;
    display: flex;
    padding: 12px;
    min-width: ${minResponseDefaultWidth}px;
    max-width: ${maxResponseDefaultWidth}px;
    box-sizing: border-box;
  }

  .block-avatar {
    min-width: 30px;
    width: 30px;
    min-height: 30px;
    height: 30px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    background: #c4c4c4;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 1px;
    color: #050f2d;
  }
  .block-details {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.065px;
    justify-content: center;
    color: #050f2d;
  }
  .block-details span {
    margin-bottom: 4px;
  }

  .student-name {
    font-weight: 600;
  }

  .block-details-important {
    font-weight: bold;
  }

  .choice-value {
    display: flex;
    align-items: center;
  }

  .choice-value div:nth-child(2) {
    margin-left: 8px;
  }

  .header-block {
    width: 100%;
    max-width: ${maxResponseDefaultWidth}px;
  }

  .header-block .block {
    flex-direction: column;
  }

  .header-correct-response {
    align-items: flex-start;
    display: flex;
    justify-content: flex-start;
    margin: 4px 0;
    position: relative;
  }

  .header-correct-answer {
    font-size: 20px;
    line-height: 23px;
    letter-spacing: -0.106611px;
    align-self: center;
    padding-left: 4px;
  }

  .header-students-number {
    font-size: 12px;
    font-weight: bold;
    line-height: 14px;
    letter-spacing: -0.106611px;
    color: #050f2d;
  }

  .header-correct-response-no-answer {
    font-size: 20px;
    line-height: 23px;
    font-weight: bold;
    padding: 8px 0;
    color: var(--pie-live-session-unanswered, ${defaultUnanswered});
  }

  .header-correct-response-value,
  .response-value {
    margin-right: 8px;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    //display: block;
    display: flex;
    text-overflow: ellipsis;
    align-items: center;
  }

  .header-correct-response-value {
    align-items: flex-start;
    min-height: 48px;
    max-height: 60px;
  }

  .header-correct-response-value-math {
    flex: 1;
  }

  .question-modal.response-value {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-right: 40px;
    font-size: 14px;
  }

  .question-modal-answer-ecr {
    margin-left: 4px;
    border: 1px solid;
    min-width: 50px;
    min-height: 12px;
    display: inline-block;
  }

  .header-correct-response-value div {
    display: flex;
    margin-left: 4px;
  }

  .header-correct-response-value-overflow {
    position: absolute;
    right: 0;
    width: 24px;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), 40%, white);
  }
  .header-correct-response-value-bottom-overflow {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 20px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), 40%, white);
  }

  .header-correct-response-value p {
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 4px;
  }

  .header-correct-response-selection {
    padding: 0 8px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 24px;
    min-width: 32px;
    min-height: 32px;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: bold;
    color: white;
    margin-right: 8px;
    text-transform: capitalize;
  }

  .question-modal.header-correct-response-selection {
    min-height: 40px;
    min-width: 40px;
    border-radius: 20px;
    margin-right: 24px;
  }

  .header-correct-response-selection.correct {
    background-color: var(--pie-live-session-correct, ${defaultCorrect});
  }

  .header-correct-response-selection.incorrect {
    background-color: var(--pie-live-session-incorrect, ${defaultIncorrect});
  }

  .header-correct-response-selection.correct-partially {
    background-color: var(--pie-live-session-partial, ${defaultPartiallyCorrect});
  }

  .header-correct-response-selection.unanswered {
    background-color: var(--pie-live-session-unanswered, ${defaultUnanswered});
  }

  .row {
    display: flex;
  }

  .more {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .more-button {
    background-color: transparent;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.106611px;
    color: #006c90;
    border-radius: 4px;
    border: none;
    padding: 0;
    font-family: var(--pie-ct-live-font-family, sans-serif);
  }

  .more-button:hover {
    cursor: pointer;
    background-color: ghostwhite;
  }

  .more-button.active {
    background-color: ghostwhite;
  }

  .more-text {
    font-size: 12px;
  }

  .expandable {
    cursor: pointer;
  }

  .correct-answer {
    color: ${defaultCorrect};
  }

  .incorrect-answer {
    color: ${defaultIncorrect};
  }


  .modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    font-family: var(--pie-ct-live-font-family), sans-serif;
  }

  .modal-content {
    background: #ffffff;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 4px;
    position: absolute;

    width: 70vw;
    max-height: 70vh;
    top: calc(50% - 35vh);
    left: calc(50% - 35vw);

    padding: 24px 24px;
    overflow: auto;
  }

  .modal-content.large {
    width: 80vw;
    max-height: 60vh;
    top: calc(50% - 30vh);
    left: calc(50% - 40vw);
  }

  .modal-response-header {
    display: flex;
    align-items: center;
  }

  .question-modal-title {
    font-size: 16px;
  }

  .modal-response-header span {
    margin-left: 12px;
  }

  .modal-response-content .response-value {
    white-space: break-spaces;
  }

  .modal-response-content {
    display: flex;
    flex-direction: column;
    margin-top: 32px;
    align-items: flex-start;
  }

  .modal-response-content .markup-math-value {
    display: inline-flex;
  }

  .modal-response-content .markup-response-value {
    display: inline-flex;
    background: #c4c4c4;
    padding: 5px;
    border-radius: 4px;
  }

  .modal-response-content .markup-response-value.correct {
    background: ${defaultCorrect};
    color: white;
  }

  .modal-response-content .markup-response-value.incorrect {
    background: ${defaultIncorrect};
    color: white;
  }

  .modal-response-content .markup-response-value.partial {
    background: ${defaultPartiallyCorrect};
    color: white;
  }

  .question-modal.modal-response-content {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .modal-response-content-row {
    display: flex;
    margin-bottom: 16px;
    align-items: flex-start;
    width: 100%;
  }

  .choice-rationale {
    display: flex;
    margin-left: 32px;
    align-items: center;
  }

  .choice-rationale-label {
    margin-right: 5px;
  }

  .view-modal-mer {
    flex-direction: column;
    letter-spacing: -0.106611px;
  }

  .question-modal.modal-response-content-row {
    margin-bottom: 64px;
    width: 50%;
  }

  .modal-close-x {
    border: none;
    background: none;
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 16px;
    width: 32px;
    height: 32px;
    color: lightgrey;
  }

  .modal-close-x:hover {
    background: ghostwhite;
  }

  .modal-close-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px;
    background: #006c90;
    border-radius: 4px;
    border: none;
    font-size: 14px;
    line-height: 14px;
    color: #ffffff;
    cursor: pointer;
  }

  .modal-close-button-container {
    display: flex;
    justify-content: flex-end;
    position: sticky;
    bottom: 0;
    right: 24px;
  }

  .answer.underlined {
    text-decoration: underline;
  }

  .answer.margins {
    margin-left: 4px;
    margin-right: 8px;
  }

  .scrollable {
    overflow-x: scroll;
  }

  .offline {
    position: relative;
  }

  .offline-label {
    font-size: 12px;
    position: absolute;
    bottom: 5px;
    right: 10px;
  }

  .offline-label-top {
    font-size: 12px;
    position: absolute;
    top: 5px;
    right: 10px;
  }

  .offline-opacity {
    opacity: 0.4;
  }`;
